import { render, staticRenderFns } from "./Acting.vue?vue&type=template&id=78aaa4b6&scoped=true&"
var script = {}
import style0 from "./Acting.vue?vue&type=style&index=0&id=78aaa4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aaa4b6",
  null
  
)

export default component.exports